import React from 'react';
import ReactDOM from 'react-dom/client';
import { flushSync } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import './Shared/Theme/theme.ts';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
if (process.env.NODE_ENV === 'production') {
  console.log = function () {};
}
/*
 * The first render is wrapped in flushSync so its effects run before the
 * browser paints it, not after (ADR 0067).
 *
 * PrimeReact 10 has no stylesheet for a component's structure - the file it
 * ships is a stub. Each component injects its own CSS from a mount effect, and
 * React runs the effects of an ordinary render after the paint. So every
 * PrimeReact control painted once unstyled and then snapped into shape: on the
 * chart pages the number input's buttons sat under it for a frame, and
 * everything below moved up 35px when the styles landed, a layout shift of
 * 0.12-0.23 on its own.
 *
 * A render inside flushSync is synchronous-priority, and React flushes the
 * passive effects of a synchronous render before it returns. The styles are
 * therefore in the document when the first frame is drawn. It costs nothing in
 * responsiveness: a first render at default priority is not time-sliced either.
 *
 * It covers what mounts in the first render. A control that mounts later still
 * injects after its paint - but that follows a click, and a shift within half
 * a second of input is not counted.
 */
flushSync(() => {
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
